export * from './wkt.service';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/wkt/shared/index.ts